var $ = require('jquery');

/**
 * Toolbar - Notification Center - Bubble Manager class
 *
 * @depends extendClass.js
 * @depends diy.simpleTooltip.js
 * @depends toolbar.js
 */
(function() {
    'use strict';
    var BubbleMgr;

    var TOP_BUBBLE_SPACING = 25,
        BUBBLE_SPACING = 25;

    BubbleMgr = Klazz.extend({
        _bubbles: null,
        toolbar: null,
        layerManager: null,
        notificationIds: null,

        initialize: function(toolbar, layerManager) {
            // Only available in the editor toolbar
            if (diy.context.type != 'editor') {
                return;
            }

            this.toolbar = toolbar;
            this.layerManager = layerManager;

            this._bubbles = [];
            this.notificationIds = new Set();

            $('#diyToolbar').bind(
                'diy-editor-toolbar-repositioned',
                $.proxy(this._recalculateBubbleOffsets, this)
            );
        },

        /**
         * Pushes a new bubble to the manager
         *
         * TODO: add documentation for the parameter
         *
         * @param notificationData
         */
        pushBubble: function(notificationData) {
            var bubbleEl = this._createBubble(notificationData);
            this._addBubble(bubbleEl);
            if (notificationData.notificationId) {
                this.notificationIds.add(notificationData.notificationId);
            }

            this.layerManager.enqueue({
                priority: 1,
                callback: function() {
                    this.emitBubble(bubbleEl);
                }.bind(this),
                blocking: false
            });
        },

        bubbleExists: function(notificationId) {
            return this.notificationIds.has(notificationId);
        },

        getNotificationIds: function() {
            return this.notificationIds;
        },

        emitBubble: function(bubbleEl) {
            bubbleEl.diy_simpleTooltip('show');
            this._recalculateBubbleOffsets();
        },

        _recalculateBubbleOffsets: function() {
            var currentTop = TOP_BUBBLE_SPACING,
                currentPos, prevBubbleEl, i;

            for (i = this._bubbles.length - 1; i >= 0; --i) {
                if (i != this._bubbles.length - 1) {
                    prevBubbleEl = this._bubbles[i + 1].diy_simpleTooltip('widget');
                    currentTop += prevBubbleEl.innerHeight() + BUBBLE_SPACING;
                }

                // Remove bubbles which are outside the viewport
                /*if (currentTop > $(window).height()) {
                    this._destroyBubble(this._bubbles[i]);
                    this._removeBubble(this._bubbles[i]);
                    i--; //we removed something which will invalidate the current index
                    continue;
                }*/

                currentPos = this._bubbles[i].diy_simpleTooltip('option', 'position');
                this._bubbles[i].diy_simpleTooltip('option', 'position', $.extend(currentPos, {
                    offset: '25 ' + currentTop
                }));
            }
        },

        _addBubble: function(element) {
            this._bubbles.push(element);
        },

        _removeBubble: function(element) {
            var bubbles = this._bubbles;

            $.each(bubbles, function(index, bubble) {
                if (element === bubble[0]) {
                    bubbles.splice(index, 1);
                    return false;
                }
            })
        },

        /**
         * creates a bubble with the following options
         * - severity: severity css class (severity-*, where * = high,medium-high, medium, medium-low, low)
         * - icon: icon css class (a 16x16 icon is used)
         * - autoHide: true/false
         * - hideDelay: if autohide is true, time in ms until the bubble disappears
         * - dismissCallback: called when the bubble is closed
         * - clickCallback: called when the bubble is clicked
         * - content: content html string
         * - contentEl: content html element (alternative to content)
         */
        _createBubble: function(notificationData) {
            var self = this,
                hasClickHandler;

            hasClickHandler = typeof notificationData.clickCallback == 'function';

            if (typeof notificationData !== 'object') {
                throw new Error("Invalid data passed to _createBubble. Parameter must be an object");
            }

            if (typeof notificationData.closable !== "boolean") {
                notificationData.closable = true;
            }

            return $('<div></div>')
                .diy_simpleTooltip({
                    autoHide : notificationData.autoHide,
                    cls: 'diy-icon-tooltip notification-bubble ' + notificationData.severity +
                        (hasClickHandler ? ' global-action' : '') +
                        (notificationData.clsSuffix ? ' notification-type-' + notificationData.clsSuffix : ''),
                    anchorTarget: this.toolbar.getElement(),
                    positionMode: 'fixed',
                    //title: 'Sample notification',
                    content: notificationData.content ? notificationData.content : null,
                    contentEl: notificationData.contentEl ? notificationData.contentEl : null,
                    contentIcon: notificationData.icon,
                    closable: notificationData.closable,
                    position: {
                        my: "left top",
                        at: "left bottom"
                    },
                    fadeOutDelay: 400,
                    show: function() {
                        var contentEl = $(this).diy_simpleTooltip('getContentEl');

                        if (notificationData.autoHide) {
                            $(this).diy_simpleTooltip('delayHide', notificationData.hideDelay);
                        }

                        contentEl.unbind('.bubble');

                        contentEl
                            .bind('mouseenter.bubble', function() {
                                $(this).diy_simpleTooltip('clearTimer', 'hide');

                                var self = $(this);
                                $('.migrationNotificationClose').on('click', function() {
                                    self.diy_simpleTooltip('hide');
                                });
                            }.bind(this))
                            .bind('mouseleave.bubble', function() {
                                if (notificationData.autoHide) {
                                    $(this).diy_simpleTooltip('delayHide', notificationData.hideDelay);
                                }
                            }.bind(this));

                        if (typeof notificationData.clickCallback == 'function') {
                            contentEl
                                .bind('click.bubble', function() {
                                    // Prevent dismiss callback from triggering on hide
                                    notificationData.dismissCallback = null;
                                    $(this).diy_simpleTooltip('hide');
                                    notificationData.clickCallback();
                                }.bind(this));
                        }
                    },
                    afterhide: function() {
                        self._destroyBubble(this);
                        self._removeBubble(this);
                        self.notificationIds.delete(notificationData.notificationId);
                        self._recalculateBubbleOffsets();

                        if (typeof notificationData.dismissCallback == 'function') {
                            notificationData.dismissCallback();
                        }
                    },
                    zIndex: diy.editor.getNewTopZIndex()
                });
        },

        _destroyBubble: function(element) {
            $(element).diy_simpleTooltip('destroy');
        },

        destroyAllBubbles: function() {
            this._bubbles.forEach(function(bubble) {
                // prevent the dismiss callback from triggering on destroy
                bubble.unbind('simpletooltipafterhide');
                this._destroyBubble(bubble);
            }.bind(this));

            this._bubbles = [];
            this.notificationIds = new Set();
        }
    });

    module.exports = BubbleMgr;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/bubble-manager.js
 ** module id = 666
 ** module chunks = 0
 **/